import { useEffect, useState } from "react";
import type { ReactNode } from "react";

type ChartsLibrary = typeof import("recharts");

type ChartsLoaderProps = {
  children: (charts: ChartsLibrary) => ReactNode;
  fallback?: ReactNode;
  errorFallback?: ReactNode;
};

export function ChartsLoader({ children, fallback, errorFallback }: ChartsLoaderProps) {
  const [charts, setCharts] = useState<ChartsLibrary | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    import("recharts/es6")
      .then((module) => {
        if (active) {
          setCharts(module);
        }
      })
      .catch((err) => {
        if (active) {
          setError(err instanceof Error ? err.message : "Unable to load charts.");
        }
      });
    return () => {
      active = false;
    };
  }, []);

  if (error) {
    return (
      errorFallback ?? (
        <p className="text-xs text-muted-foreground">Chart unavailable.</p>
      )
    );
  }

  if (!charts) {
    return fallback ?? null;
  }

  return <>{children(charts)}</>;
}
